define("Utility/SiteContext", ["require", "exports"], function (require, exports) {
    "use strict";
    var SiteContext = /** @class */ (function () {
        function SiteContext() {
        }
        SiteContext.prototype.isPageEditor = function () {
            if (typeof Sitecore == "undefined") {
                return false;
            }
            if (typeof Sitecore.PageModes == "undefined" || Sitecore.PageModes == null) {
                return false;
            }
            return Sitecore.PageModes.PageEditor != null;
        };
        SiteContext.prototype.getContextLanguage = function () {
            return document.getElementsByTagName("body")[0].getAttribute("data-page-language-name"); //document.documentElement.lang;
        };
        return SiteContext;
    }());
    return new SiteContext();
});
///<amd-module name="Globalization/Dictionary"/>
define("Globalization/Dictionary", ["require", "exports", "jquery", "Utility/SiteContext"], function (require, exports, $, siteContext) {
    "use strict";
    var Dictionary = /** @class */ (function () {
        function Dictionary() {
            this.loadValues();
        }
        Dictionary.prototype.translate = function (key) {
            return this.values != null ? this.values[key] || key : key;
        };
        Dictionary.prototype.getContextLanguage = function () {
            return siteContext.getContextLanguage();
        };
        Dictionary.prototype.loadValues = function () {
            var language = this.getContextLanguage();
            var valuesUrl = "/temp/dictionary." + language + ".json";
            // We disable browser's cache to ensure translations are up to date
            $.ajax({ cache: false, async: false, url: valuesUrl })
                .done(function (data) {
                this.values = Object.freeze(data);
            }.bind(this))
                .fail(function () {
                console.error("Couldn't load dictionary values");
            });
        };
        return Dictionary;
    }());
    return new Dictionary();
});
define("BriteVerifyValidation/BriteVerifyValidationHelper", ["require", "exports", "jquery", "Globalization/Dictionary"], function (require, exports, $, dictionary) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var BriteVerifyValidationHelper = /** @class */ (function () {
        function BriteVerifyValidationHelper() {
            // Tracks the validation state
            this.isPhoneValidForBriteVerify = null;
            this.isEmailValidForBriteVerify = null;
        }
        BriteVerifyValidationHelper.prototype.checkDuplicateCountryCodeInPhoneNo = function (form) {
            if (!form.find("#WorkPhone").val()) {
                return;
            }
            var countryPhoneCodeElement = form.find('[name="CountryPhoneCode"]');
            var countryPhoneCode = countryPhoneCodeElement.length > 0
                ? countryPhoneCodeElement.find(':selected').text()
                : null;
            if (countryPhoneCode) {
                var countryCodeMatch = countryPhoneCode.match(/(\+\d+)/);
                var workPhone = form.find("#WorkPhone").val();
                var updatedWorkPhone = workPhone.replace(countryCodeMatch[0], "").trim();
                if (countryCodeMatch[0] == "+1" && workPhone.charAt(0) == "1") {
                    updatedWorkPhone = workPhone.replace(/^1([+\s-])?/, '');
                }
                if (updatedWorkPhone.charAt(0) == "-") {
                    updatedWorkPhone = updatedWorkPhone.substring(1);
                }
                // Check if the selected country is part of the North American Numbering Plan (NANP),
                // which includes the US, Canada, and certain Caribbean nations.
                // NANP country codes follow the pattern: +1-XXX (e.g., +1-473 for Grenada, +1-876 for Jamaica).
                var nanpCodeMatch = countryPhoneCode.match(/\+1-\d{3}/);
                if (nanpCodeMatch) {
                    // Matches "-XXX" with the optional trailing dash at the start of the phone number (only if it follows a NANP format)
                    var nanpPrefixPattern = /^-\d{3}-?/;
                    updatedWorkPhone = updatedWorkPhone.replace(nanpPrefixPattern, "").trim();
                }
                form.find("#WorkPhone").val(updatedWorkPhone).valid();
            }
        };
        BriteVerifyValidationHelper.prototype.verifyPhoneWithCountryCode = function (form, validatePhone) {
            //Check duplicate country code
            this.checkDuplicateCountryCodeInPhoneNo(form);
            // Check if the phone should be validated and if the WorkPhone field has a value
            if (!validatePhone || !form.find("#WorkPhone").val()) {
                return;
            }
            // Retrieve the selected country phone code, if the element exists
            var countryPhoneCodeElement = form.find('[name="CountryPhoneCode"]');
            var countryPhoneCode = countryPhoneCodeElement.length > 0
                ? countryPhoneCodeElement.find(':selected').text()
                : null;
            // Extract the phone code if it exists (only numbers and "+" sign)
            var phoneCodeMatch = countryPhoneCode ? countryPhoneCode.match(/(\+\d+)/) : null;
            // Set phoneInput, using the extracted phone code if available, or default to workPhone
            var workPhone = form.find("#WorkPhone").val();
            var phoneInput = phoneCodeMatch ? phoneCodeMatch[0] + workPhone : workPhone;
            var self = this;
            // Make the AJAX request to verify the phone
            $.ajax({
                url: "/VerifyPhone",
                method: 'POST',
                data: { phone: phoneInput },
                success: function (response) {
                    console.log("BriteVerify Api results:", response);
                    self.isPhoneValidForBriteVerify = response.isPhoneValid;
                    // Trigger error if the phone is invalid
                    if (!response.isPhoneValid) {
                        self.triggerError(form, "WorkPhone", dictionary.translate("Briteverify Invalid Phone Message"));
                    }
                    else
                        self.clearErrorMessage(form, "WorkPhone");
                },
                error: function (error) {
                    console.error("Error during Brite Verify API request:", error);
                }
            });
        };
        BriteVerifyValidationHelper.prototype.validateWorkEmail = function (form, isBusinessServicesForm) {
            var workEmail = form.find("#WorkEmail").val();
            var isDefaultForm = form.is(".eloqua-global-form, .eloqua-master-form, .eloqua-media-asset-form");
            // Remove the confirmation message if it already exists
            form.find('div#confirm-submitting-personal-email').remove();
            var self = this;
            if (workEmail) {
                $.ajax({
                    url: "/VerifyEmail",
                    method: 'POST',
                    data: { email: workEmail, isDefaultForm: isDefaultForm },
                    success: function (response) {
                        self.clearErrorMessage(form, "WorkEmail");
                        console.log("BriteVerify Api results:", response);
                        self.isEmailValidForBriteVerify = response.isEmailValid;
                        if (!response.isEmailValid) {
                            if (response.isBlockedEmail) {
                                self.triggerError(form, "WorkEmail", dictionary.translate("Briteverify Blocked Email Message"));
                            }
                            else {
                                self.triggerError(form, "WorkEmail", dictionary.translate("Briteverify Invalid Email Message"));
                            }
                            return;
                        }
                        form.find("#EmailAddressStatus").val(response.status);
                        if (response.isPersonalEmail) {
                            if (isBusinessServicesForm) {
                                form.find("#EmailAddressStatus").val("valid-personal");
                                self.addCheckboxAndTextToBusinessServicesForms(form);
                                self.triggerError(form, "WorkEmail", dictionary.translate("Briteverify Personal Email Error Message"));
                            }
                            else {
                                //Check AcceptPersonalEmail Checkbox on Eloqua Master, Eloqua Gloabl and Eloqua Media Asset Form
                                if (form.find('[name="AcceptPersonalEmail"]').length > 0 && form.find('[name="AcceptPersonalEmail"]').val() == "True") {
                                    form.find("#EmailAddressStatus").val("valid-personal");
                                    return;
                                }
                                // Non-BS forms should not accept personal emails
                                self.isEmailValidForBriteVerify = false;
                                self.triggerError(form, "WorkEmail", dictionary.translate("Briteverify Invalid Email Message"));
                            }
                            return;
                        }
                    },
                    error: function (error) {
                        console.error("Error during Brite Verify API request:", error);
                    }
                });
            }
        };
        BriteVerifyValidationHelper.prototype.addCheckboxAndTextToBusinessServicesForms = function (form) {
            // Remove the div if it already exists
            form.find('div#confirm-submitting-personal-email').remove();
            var submitButton = form.find('button[type="submit"]');
            if (submitButton.length) {
                var parentDiv = submitButton.closest('div');
                if (parentDiv) {
                    // Create the new div
                    var newDiv = document.createElement('div');
                    newDiv.className = 'form-group long';
                    newDiv.id = 'confirm-submitting-personal-email';
                    // Create the span element
                    var confirmMessage = dictionary.translate('Briteverify Personal Email Submission Confirmation Message');
                    var span = document.createElement('span');
                    span.textContent = confirmMessage;
                    span.style.color = '#ed1c24';
                    span.style.fontSize = '14px';
                    // Create the checkbox element
                    var checkbox = document.createElement('input');
                    checkbox.type = 'checkbox';
                    checkbox.id = 'acceptPersonalEmail';
                    checkbox.style.marginLeft = '5px';
                    checkbox.style.width = '16px';
                    checkbox.style.height = '16px';
                    // Append the span and checkbox to the new div
                    newDiv.appendChild(span);
                    newDiv.appendChild(checkbox);
                    // Insert the new div before the parent div of the submit button
                    parentDiv.before(newDiv);
                    var self_1 = this;
                    $(checkbox).on('click', function () {
                        if ($(this).is(':checked')) {
                            $(this).removeClass("accept-personal-mail-error");
                            self_1.clearErrorMessage(form, "WorkEmail");
                        }
                        else {
                            $(this).addClass("accept-personal-mail-error");
                            self_1.triggerError(form, "WorkEmail", dictionary.translate("Briteverify Personal Email Error Message"));
                        }
                    });
                }
            }
        };
        BriteVerifyValidationHelper.prototype.triggerError = function (form, fieldName, message) {
            var errorMessage = message;
            // If no custom message is provided, fetch the appropriate error message attribute
            if (!errorMessage) {
                if (fieldName === "WorkPhone") {
                    errorMessage = form.find("#" + fieldName).attr("data-val-phonewithcountrycode");
                }
                else if (fieldName === "WorkEmail") {
                    errorMessage = form.find("#" + fieldName).attr("data-val-regex");
                }
            }
            if (errorMessage) {
                // Remove any previous error class and set the error message
                form
                    .find("[data-valmsg-for=\"" + fieldName + "\"]")
                    .removeClass()
                    .addClass("field-validation-error")
                    .html("<span class=\"error\">" + errorMessage + "</span>");
                // Add input-validation-error class and set aria-invalid to true
                form
                    .find("#" + fieldName)
                    .addClass("input-validation-error")
                    .attr("aria-invalid", "true");
            }
        };
        BriteVerifyValidationHelper.prototype.clearErrorMessage = function (form, fieldName) {
            if (!form || !fieldName)
                return;
            // Remove the error message and reset classes
            form
                .find("[data-valmsg-for=\"" + fieldName + "\"]")
                .removeClass("field-validation-error")
                .html(""); // Clear the error message content
            // Remove input-validation-error class and reset aria-invalid
            form
                .find("#" + fieldName)
                .removeClass("input-validation-error")
                .attr("aria-invalid", "false");
        };
        return BriteVerifyValidationHelper;
    }());
    exports.default = new BriteVerifyValidationHelper();
});
///<amd-module name="Components/Buttons/VideoModalButton"/>
define("Components/Buttons/VideoModalButton", ["require", "exports", "jquery", "eventManager", "//www.youtube.com/iframe_api", "//player.vimeo.com/api/player.js"], function (require, exports, $) {
    "use strict";
    var eventManager = require("eventManager");
    var vimeoPlayer = require("//player.vimeo.com/api/player.js");
    var VideoModalButton = /** @class */ (function () {
        function VideoModalButton(args) {
            this.$scope = $(args.scope);
            this.autoplay = args.autoplay;
            this.showVimeo = args.showVimeo;
            this.vimeoAutoplay = args.vimeoAutoplay;
            this.stateChangeMessages = [];
            $(".modal", args.scope).on('shown.bs.modal', function () {
                if (this.showVimeo) {
                    if (this.vimeoAutoplay) {
                        this.player.play();
                    }
                }
                else {
                    if (this.autoplay) {
                        this.play();
                    }
                }
            }.bind(this));
            $(".modal", args.scope).on('hidden.bs.modal', function () {
                if (this.showVimeo) {
                    this.player.pause();
                }
                else {
                    if (this.autoplay) {
                        this.pause();
                    }
                }
            }.bind(this));
            if (this.showVimeo) {
                var videoId = this.$scope.find('iframe').attr('id');
                console.log(videoId);
                if (!videoId) {
                    var lastVideoModal = $(".video-modal-button.last");
                    if (lastVideoModal.length > 0) {
                        videoId = $(lastVideoModal).find('iframe').attr('id');
                    }
                }
                Object.defineProperties(this, {
                    videoId: { enumerable: true, value: videoId },
                    player: { enumerable: false, value: new vimeoPlayer(videoId) }
                });
            }
            else {
                YT.ready(function () {
                    var videoId = this.$scope.find('iframe').attr('id');
                    Object.defineProperties(this, {
                        videoId: { enumerable: true, value: videoId },
                        player: { enumerable: false, value: new YT.Player(videoId) }
                    });
                    this.player.addEventListener("onStateChange", this.transmitStateChange.bind(this));
                }.bind(this));
            }
        }
        VideoModalButton.prototype.play = function () {
            this.$scope.find('iframe')
                .get(0)
                .contentWindow
                .postMessage(JSON.stringify({
                'event': 'command',
                'func': 'playVideo',
                'args': [],
                'id': 'test-player'
            }), "*");
        };
        VideoModalButton.prototype.pause = function () {
            this.$scope.find('iframe')
                .get(0)
                .contentWindow
                .postMessage(JSON.stringify({
                'event': 'command',
                'func': 'pauseVideo',
                'args': [],
                'id': 'test-player'
            }), "*");
        };
        VideoModalButton.prototype.addStateChangeMessage = function (message) {
            if (!message)
                return;
            if (this.stateChangeMessages.indexOf(message) > -1) {
                console.log("Component is already registered for event " + message);
                return;
            }
            this.stateChangeMessages.push(message);
        };
        VideoModalButton.prototype.transmitStateChange = function () {
            var messages = this.stateChangeMessages;
            if (messages.length) {
                messages.forEach(function (ev) {
                    eventManager.trigger(ev, this, this.player);
                }.bind(this));
            }
        };
        return VideoModalButton;
    }());
    function init(args) {
        return new VideoModalButton(args);
    }
    define("VideoModalButton", [], function () {
        return init;
    });
    return init;
});
define("Validation/UnobtrusiveValidationExtensions", ["require", "exports", "jquery"], function (require, exports, $) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var UnobtrusiveValidationExtensions = /** @class */ (function () {
        function UnobtrusiveValidationExtensions() {
        }
        UnobtrusiveValidationExtensions.prototype.resetFormValidation = function (form) {
            // We need to remove previous validation set by $.validator.unobtrusive.parse()
            // in order to attach additional score validation adapters (requiredor) to the form
            // http://stackoverflow.com/questions/14902581/unobtrusive-validation-not-working-with-dynamic-content
            var $form = $(form)
                .removeData("validator")
                .removeData("unobtrusiveValidation");
            $.validator.unobtrusive.parse($form);
        };
        UnobtrusiveValidationExtensions.prototype.parseDynamicContent = function (selector) {
            // don't use the normal unobstrusive.parse method
            // $.validator.unobtrusive.parse(selector); 
            // use this instead:
            $(selector).find('*[data-val = true]').each(function () {
                $.validator.unobtrusive.parseElement(this, false);
            });
            //get the relevant form
            var form = $(selector).first().closest('form');
            //get the collections of unobstrusive validators, and jquery validators
            //and compare the two
            var unobtrusiveValidation = form.data('unobtrusiveValidation');
            var validator = form.validate();
            $.each(unobtrusiveValidation.options.rules, function (elname, elrules) {
                if (validator.settings.rules[elname] == undefined) {
                    var args = {};
                    $.extend(args, elrules);
                    args.messages = unobtrusiveValidation.options.messages[elname];
                    $('[name="' + elname + '"]').rules("add", args);
                }
                else {
                    $.each(elrules, function (rulename, data) {
                        if (validator.settings.rules[elname][rulename] == undefined) {
                            var args = {};
                            args[rulename] = data;
                            args.messages = unobtrusiveValidation.options.messages[elname][rulename];
                            $('[name="' + elname + '"]').rules("add", args);
                        }
                    });
                }
            });
        };
        return UnobtrusiveValidationExtensions;
    }());
    exports.UnobtrusiveValidationExtensions = UnobtrusiveValidationExtensions;
});
//export = UnobtrusiveValidationExtensions; 
///<amd-module name="Validation/RecaptchaApiLoader"/>
define("Validation/RecaptchaApiLoader", ["require", "exports", "eventManager"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var eventManager = require('eventManager');
    var lang = document.documentElement.lang.substring(0, 2);
    // Trigger event when Google Recaptcha Api is loaded so all forms can render their own captchas
    window['onRecaptchaApiLoaded'] = function () { return eventManager.trigger("RecaptchaApiLoaded"); };
    require(['https://www.recaptcha.net/recaptcha/api.js?onload=onRecaptchaApiLoaded&render=explicit&hl=' + lang], function () { return console.log('Recaptcha api is loaded.'); });
});
///<amd-module name="Components/Forms/EloquaMasterForm"/>
define("Components/Forms/EloquaMasterForm", ["require", "exports", "jquery", "Validation/UnobtrusiveValidationExtensions", "Globalization/Dictionary", "Utility/SiteContext", "BriteVerifyValidation/BriteVerifyValidationHelper", "jqueryValidate", "jqueryValidateUnobtrusive", "jqueryUnobtrusiveAjax", "scoreunobtrusive", "bootstrapSelect", "Validation/RecaptchaApiLoader", "mustache", "Utility/ErrorHandler", "eventManager"], function (require, exports, $, UnobtrusiveValidationExtensions_1, dictionary, siteContext, BriteVerifyValidationHelper) {
    "use strict";
    var eventManager = require('eventManager');
    var events = require("Track/Events");
    var errorHandler = require("Utility/ErrorHandler");
    var EloquaMasterForm = /** @class */ (function () {
        function EloquaMasterForm(options) {
            var _this = this;
            this.validationHelper = new UnobtrusiveValidationExtensions_1.UnobtrusiveValidationExtensions();
            this.options = options;
            this.form = $('#' + this.options.formId, this.options.scope);
            this.formName = this.options.mediaAsset ? "Media Asset Form" : "Master Lead Form";
            if (this.options.progressiveProfiling) {
                this.formName = this.options.formName;
            }
            else if ($(".business-services-registration-form", this.options.scope).length > 0) {
                this.formName = "Business Services Registration Form";
            }
            this.isPreview = $("body").attr("is-preview") === "True";
            this.isBusinessServicesForm = Array.from(this.form[0].classList).some(function (cls) { return cls.startsWith('business-services'); });
            this.validateEmail = this.form.find("#ValidateEmail").length > 0 && $(this.form).find("#ValidateEmail").val() === "True";
            this.validatePhone = false;
            this.setWorkPhoneValidation();
            $('[name="Country"]', this.options.scope).on('change', this.onCountryChanged.bind(this));
            $('[name="Industry"]', this.options.scope).on('change', this.onIndustryChanged.bind(this));
            $('[name="SubIndustry"]', this.options.scope).on('change', this.onSubIndustryChanged.bind(this));
            $('[name="EloquaFormName"]', this.options.scope).on('change', this.onFormChanged.bind(this));
            $('#download', this.options.scope).on('click', this.triggerVWOEventOnDownload.bind(this));
            // init other dropdowns based on industry in case if industry is predefined
            if (!siteContext.isPageEditor())
                $('[name="Industry"]', this.options.scope).trigger('change');
            //trigger change event on load
            if (!siteContext.isPageEditor())
                $('[name="EloquaFormName"]', this.options.scope).trigger('change');
            //update country
            $.ajax({
                url: '/GetLocationInfo',
                method: 'get',
                cache: false
            })
                .done(function (data) {
                this.onLocationDataLoaded(data);
                this.updateValidatePhone();
            }.bind(this));
            this.validationHelper.resetFormValidation(this.form);
            this.form.on('submit', this.onFormSubmit.bind(this));
            // init dropdowns manually, for some reason implicit initialization doesn't work
            $('.selectpicker', this.options.scope).selectpicker();
            // Hide validation error message for selectpickers in case if user selected valid value
            $('select', this.options.scope).on('change', function (e) { return $(e.target).valid(); });
            //Remove dropdown error class if selected value is valid
            $('select', this.options.scope).on('change', function () { if ($(this).valid()) {
                $(this).siblings().removeClass('error');
            } });
            $('#CountryPhoneCode', this.options.scope).on('change', function () {
                var countryPhoneCodeSelect = $('[name="CountryPhoneCode"]', _this.options.scope);
                var countrySelect = $('[name="Country"]', _this.options.scope);
                if (countrySelect.length > 0) {
                    if (countryPhoneCodeSelect.val() != countrySelect.val()) {
                        _this.populateContryWithCountryPhoneCode();
                    }
                }
                BriteVerifyValidationHelper.default.verifyPhoneWithCountryCode(_this.form, _this.validatePhone);
            });
            // Show error message when user leaves input
            $('select, input', this.options.scope).on('blur', function (e) {
                // BriteVerify Email field validation
                if ($(e.target).attr('id') === 'WorkEmail' && _this.validateEmail) {
                    BriteVerifyValidationHelper.default.validateWorkEmail(_this.form, _this.isBusinessServicesForm);
                }
                else if ($(e.target).attr('id') === 'WorkPhone') {
                    BriteVerifyValidationHelper.default.verifyPhoneWithCountryCode(_this.form, _this.validatePhone);
                }
                else {
                    $(e.target).valid();
                }
            });
            function getCookie(key) {
                var keyValue = document.cookie.match("(^|;) ?" + key + "=([^;]*)(;|$)");
                return keyValue ? keyValue[2] : null;
            }
            //check cookies
            if (!siteContext.isPageEditor()) {
                if (this.options.isAutoResponderEnabled) {
                    $('.download', this.options.scope).hide();
                    $('.gated-url-redirect', this.options.scope).hide();
                    this.form.show();
                    eventManager.subscribe("StickyAchorMenuLoaded", function () {
                        eventManager.trigger("MatchHeightRefresh");
                    });
                    return;
                }
                var idCookie = getCookie('Id' + this.options.pageId.Guid + '_' + this.options.itemId.Guid);
                if (idCookie) {
                    var assetUrl = $('[name="AssetUrl"]', this.options.scope).val();
                    var isMediaAssetForm = this.options.scope.className.indexOf("media-asset-form") !== -1;
                    if (assetUrl.length > 0) {
                        if (isMediaAssetForm && this.options.hasGatedLinkUrl) {
                            $('.gated-url-redirect', this.options.scope).show();
                        }
                        else {
                            if (assetUrl.indexOf("/media/") > 0) {
                                $('#download', this.options.scope).attr('href', assetUrl);
                                if (assetUrl.indexOf('.pdf') != -1) {
                                    $('#download', this.options.scope).attr('target', '_blank');
                                }
                                $('.download', this.options.scope).show();
                            }
                        }
                    }
                    $('.video-button', this.options.scope).show();
                    $('.score-well', this.options.scope).hide();
                }
                else {
                    $('.download', this.options.scope).hide();
                    $('.gated-url-redirect', this.options.scope).hide();
                    this.form.show();
                }
                eventManager.subscribe("StickyAchorMenuLoaded", function () {
                    eventManager.trigger("MatchHeightRefresh");
                });
            }
        }
        EloquaMasterForm.prototype.updateValidatePhone = function () {
            var skipPhoneValidation = this.form.find("#SkipWorkPhoneValidation").length > 0 && this.form.find("#SkipWorkPhoneValidation").val() === "True";
            var countrySelect = $('[name="Country"]', this.options.scope);
            this.validatePhone = false;
            BriteVerifyValidationHelper.default.clearErrorMessage(this.form, "WorkPhone");
            BriteVerifyValidationHelper.default.isPhoneValidForBriteVerify = null;
            if (!skipPhoneValidation && $('[name="ValidatePhone"]', this.options.scope).length > 0) {
                if ($('[name="ValidatePhone"]', this.options.scope).val() === "True" && countrySelect.val() == "USA") {
                    this.validatePhone = true;
                }
            }
        };
        EloquaMasterForm.prototype.populateContryWithCountryPhoneCode = function () {
            // Retrieve the selected country phone code, if the element exists 
            var countryPhoneCodeElement = $('[name="CountryPhoneCode"]', this.options.scope);
            var countryCode = countryPhoneCodeElement.length > 0
                ? countryPhoneCodeElement.find(':selected').val()
                : null;
            if (countryCode) {
                var countrySelect = $('[name="Country"]', this.options.scope);
                $(countrySelect).val(countryCode).change();
            }
        };
        EloquaMasterForm.prototype.setWorkPhoneValidation = function () {
            var countryPhoneCodeElement = this.form.find('[name="CountryPhoneCode"]');
            var self = this;
            if (countryPhoneCodeElement.length > 0) {
                $.validator.addMethod("phonewithcountrycode", function (value, element, params) {
                    // Retrieve the country code field's text value
                    var countryCodeText = $(this.currentForm).find('[data-id="CountryPhoneCode"]').attr('title');
                    var countryCode = "";
                    if (countryCodeText) {
                        // Match only digits
                        var match = countryCodeText.match(/\(\+?(\d+)\)/);
                        // Extract the phone code
                        countryCode = match ? match[1] : "";
                    }
                    var isUSA = countryCodeText && countryCodeText.includes("United States");
                    if (isUSA) {
                        var fullPhoneNumber = countryCode + value;
                        var pattern = new RegExp(params.pattern);
                        return pattern.test(fullPhoneNumber); // US strict validation
                    }
                    // Basic check for non-US: digits, spaces, dashes, parentheses
                    return /^[\d\s\-()]+$/.test(value);
                }, "Invalid phone number format.");
                $.validator.unobtrusive.adapters.add("phonewithcountrycode", ["countryCodeField", "pattern"], function (options) {
                    options.rules["phonewithcountrycode"] = {
                        countryCodeField: options.params.countryCodeField,
                        pattern: options.params.pattern
                    };
                    options.messages["phonewithcountrycode"] = options.message;
                });
            }
        };
        EloquaMasterForm.prototype.prependCountryCodeToWorkPhone = function () {
            var countryPhoneCodeElement = this.form.find('[name="CountryPhoneCode"]');
            var workPhoneElement = this.form.find('[name="WorkPhone"]');
            if (countryPhoneCodeElement.length > 0 && workPhoneElement.length > 0) {
                var countryCodeText = countryPhoneCodeElement.find(":selected").text();
                var countryCodeMatch = countryCodeText.match(/(\+\d+)/);
                if (countryCodeMatch) {
                    var countryCodeOnly = countryCodeMatch[0];
                    var currentPhoneValue = workPhoneElement.val();
                    // Prepend the country code to the existing value
                    workPhoneElement.val(countryCodeOnly + currentPhoneValue);
                }
            }
        };
        EloquaMasterForm.prototype.onLocationDataLoaded = function (data) {
            this.locationInfo = data;
            if (!(typeof this.locationInfo === "undefined") && this.locationInfo.Country !== null && this.locationInfo.Country !== 'undefined' && this.locationInfo.Country !== '') {
                if (this.locationInfo.Country === 'United States') {
                    $('[name="Country"], [name="CountryPhoneCode"]', this.options.scope)
                        .val('USA')
                        .change();
                }
                else {
                    $('[name="Country"], [name="CountryPhoneCode"]', this.options.scope)
                        .val(this.locationInfo.Country)
                        .change();
                }
            }
            else {
                console.log('Location not available. Country undefined.');
            }
        };
        EloquaMasterForm.prototype.onFormChanged = function (e) {
            var _this = this;
            var formId = ($('[name="EloquaFormName"]', this.options.scope).val());
            //this.logFieldValues(formId, this);
            if (formId) {
                if (this.isPreview)
                    return;
                $.get(this.options.url, { formId: formId })
                    .fail(function (data) {
                    var errors = data.responseJSON;
                    errorHandler.logError(errors);
                    _this.setFieldIdsFailSubmitHandler(formId, _this);
                })
                    .done(function (response) {
                    var data = jQuery.parseJSON(response);
                    for (var _i = 0, _a = data.elements; _i < _a.length; _i++) {
                        var element = _a[_i];
                        if ($('[eloquaName=' + element.htmlName + ']', _this.options.scope)) {
                            $('[eloquaName=' + element.htmlName + ']', _this.options.scope).attr('eloquaID', element.id);
                        }
                        // pass Submission Server Field id to the Model
                        if (element.htmlName === "submissionServer" && $('[name="SubmissionServerFieldId"]', _this.options.scope).length > 0) {
                            $('[name="SubmissionServerFieldId"]', _this.options.scope).val(element.id);
                        }
                        if (element.htmlName === "assetURL" && $('[eloquaName=' + element.htmlName + ']', _this.options.scope).length > 0) {
                            sessionStorage.setItem(element.id, $('[eloquaName=' + element.htmlName + ']', _this.options.scope).val());
                            $('[eloquaName=' + element.htmlName + ']', _this.options.scope).val('');
                        }
                    }
                });
            }
            else {
                var error = "Eloqua Form Name field value is not set";
                errorHandler.logError(error);
            }
        };
        EloquaMasterForm.prototype.colectFormValues = function (form) {
            var inputControls = form.find('div.form-group').find('input.form-control');
            var selectFilters = form.find('div.form-group').find('button.dropdown-toggle');
            var textAreas = form.find('textarea');
            var fieldValues = '';
            $.each(inputControls, function (index, field) {
                fieldValues = fieldValues + field.name + '=' + field.value + ';';
            });
            $.each(selectFilters, function (index, filter) {
                fieldValues = fieldValues + $(filter).attr('data-id') + '=' + $(filter).attr('title') + ';';
            });
            $.each(textAreas, function (index, textArea) {
                fieldValues = fieldValues + $(textArea).attr('placeholder') + '=' + $(textArea).val() + ';';
            });
            return fieldValues;
        };
        /*private logFieldValues(formId, eloquaForm) {
                var self = this;
                $("form").submit(function (event) {
                        if (eloquaForm.form.valid()) {
                                var fieldValues = self.colectFormValues($(this));
    
                                $.post("/LogFormInputs", { formId: formId, fieldValues: fieldValues }, function () { });
                        }
                });
        }*/
        EloquaMasterForm.prototype.setFieldIdsFailSubmitHandler = function (formId, eloquaForm) {
            var self = this;
            $("form").submit(function (event) {
                event.preventDefault();
                if (eloquaForm.form.valid()) {
                    if (!self.performBriteVerifyValidation()) {
                        return false;
                    }
                    self.prependCountryCodeToWorkPhone();
                    var fieldValues = self.colectFormValues($(this));
                    $.post("/SubmitAfterGetIdFails", { formId: formId, fieldValues: fieldValues }, function () {
                        $('.score-well', eloquaForm.options.scope).show().addClass("in");
                        eloquaForm.form.hide();
                        $('.score-well', eloquaForm.options.scope)[0].scrollIntoView({ behavior: 'smooth' });
                    });
                }
            });
        };
        EloquaMasterForm.prototype.performBriteVerifyValidation = function () {
            // Email validation
            if (BriteVerifyValidationHelper.default.isEmailValidForBriteVerify === false) {
                BriteVerifyValidationHelper.default.triggerError(this.form, "WorkEmail", dictionary.translate("Briteverify Invalid Email Message"));
            }
            // Phone validation
            if (BriteVerifyValidationHelper.default.isPhoneValidForBriteVerify === false) {
                BriteVerifyValidationHelper.default.triggerError(this.form, "WorkPhone", dictionary.translate("Briteverify Invalid Phone Message"));
            }
            if (BriteVerifyValidationHelper.default.isPhoneValidForBriteVerify === false
                || BriteVerifyValidationHelper.default.isEmailValidForBriteVerify === false)
                return false;
            return true;
        };
        EloquaMasterForm.prototype.validatePersonalEmailAcceptance = function () {
            var acceptPersonalEmailCheckbox = $(this.form).find('#acceptPersonalEmail');
            if (acceptPersonalEmailCheckbox.length > 0 && !acceptPersonalEmailCheckbox.is(':checked')) {
                BriteVerifyValidationHelper.default.triggerError(this.form, "WorkEmail", dictionary.translate("Briteverify Personal Email Error Message"));
                // Add an error class to the checkbox
                acceptPersonalEmailCheckbox.addClass("accept-personal-mail-error");
                return false;
            }
            return true;
        };
        EloquaMasterForm.prototype.trackErrors = function (formErrors) {
            eventManager.trigger(events.global.formErrors, this.formName, formErrors);
        };
        EloquaMasterForm.prototype.onFormSubmit = function () {
            if (this.isPreview)
                return false;
            var isFormValid = this.form.valid();
            if (!isFormValid) {
                $('select.input-validation-error', this.options.scope).siblings().addClass('error');
            }
            var isPersonalEmailCheckboxValid = this.isBusinessServicesForm ? this.validatePersonalEmailAcceptance() : true;
            var isBriteVerifyValid = this.performBriteVerifyValidation();
            if (!isPersonalEmailCheckboxValid || !isFormValid || !isBriteVerifyValid) {
                var textArray_1 = [];
                $('.field-validation-error', this.options.scope).each(function () {
                    if ($(this).parent().css('display') !== 'none') {
                        var text = $(this).text().trim();
                        if (text !== '') {
                            textArray_1.push(text);
                        }
                    }
                });
                var errors = this.form.validate().errorList;
                if (errors.length > 0 || textArray_1.length > 0) {
                    var allErrors = [];
                    var errorList = [];
                    if (errors.length > 0)
                        errorList = errors.map(function (e) { return e.message; });
                    allErrors = errorList.concat(textArray_1);
                    allErrors = $.grep(allErrors, function (value, index) {
                        return $.inArray(value, allErrors) === index;
                    });
                    this.trackErrors(allErrors);
                }
                return false;
            }
            var cookieValue = document.cookie.match("(^|;) ?" + 'OptanonConsent' + "=([^;]*)(;|$)");
            var optanonConsentCookieValue = cookieValue ? cookieValue[2] : "";
            if (optanonConsentCookieValue.length > 0) {
                var optanonConsent = decodeURIComponent(optanonConsentCookieValue);
                var parts = optanonConsent.split("&groups=");
                if (parts.length == 2) {
                    var groupValue = parts.pop().split("&").shift();
                    $('#' + this.options.formId).find('[name="OptanonActiveGroups"]').val(groupValue);
                }
            }
            var assetUrl = $('[name="AssetUrl"]', this.options.scope);
            if (assetUrl) {
                var url = sessionStorage.getItem($(assetUrl).attr('eloquaid'));
                assetUrl.val(url);
            }
            var originalCaptchaInputName = $('[data-recaptcha]', this.options.scope).attr('name');
            $('[data-recaptcha]', this.options.scope).attr('name', originalCaptchaInputName + '.Response');
            var submissionId = (($("[name=EloquaFormName]", this.options.scope).val()).length < 6 ? '00' : '') + $("[name=EloquaFormName]", this.options.scope).val();
            var currentDate = new Date(Date.now());
            //var date1 = (('' + day).length < 2 ? '0' : '') + day + '/' + (('' + month).length < 2 ? '0' : '') + month + '/' + date.getFullYear();
            var year = currentDate.getFullYear();
            var month = (('' + currentDate.getMonth()).length < 2 ? '0' : '') + (currentDate.getMonth() + 1);
            var date = (('' + currentDate.getDate()).length < 2 ? '0' : '') + currentDate.getDate();
            var hour = (('' + currentDate.getHours()).length < 2 ? '0' : '') + currentDate.getHours();
            var minute = (('' + currentDate.getMinutes()).length < 2 ? '0' : '') + currentDate.getMinutes();
            var second = (('' + currentDate.getSeconds()).length < 2 ? '0' : '') + currentDate.getSeconds();
            var miliSec = (('' + currentDate.getMilliseconds()).length < 2 ? '0' : '') + currentDate.getMilliseconds();
            miliSec = (('' + miliSec).length < 3 ? '0' : '') + miliSec;
            submissionId += '-' + year + month + date + hour + minute + second + miliSec;
            if (this.options.contentDeliveryName !== null && this.options.contentDeliveryName !== undefined && this.options.contentDeliveryName !== '') {
                submissionId += '-' + this.options.contentDeliveryName;
            }
            this.submissionId = submissionId;
            $('input[name="SubmissionId"]', this.options.scope).val(submissionId);
            console.log("This is the submissionID now: " + submissionId);
            this.piiSafeValues = this.getPiiSafeValues();
            this.vwoEventValues = this.getVWOEventValues();
            this.prependCountryCodeToWorkPhone();
            //create Eloqua FieldValues
            var inputs = this.form[0].elements;
            var fieldValues = [];
            for (var _i = 0, inputs_1 = inputs; _i < inputs_1.length; _i++) {
                var input = inputs_1[_i];
                var id = $(input).attr('eloquaID');
                if (id) {
                    var value = $(input).is(':checkbox') ? $(input).prop('checked').toString() : $(input).val();
                    var fieldValue = {
                        type: 'FieldValue',
                        id: id,
                        value: value
                    };
                    fieldValues.push(fieldValue);
                }
            }
            //create Eloqua Request
            var request = {
                fieldValues: fieldValues
            };
            $('[name="Request"]', this.options.scope).val(JSON.stringify(request));
            $('button[type="submit"]', this.options.scope).prop('disabled', true);
            //var formSubmitApi = this.form.attr("action");
            var formSubmitApi = encodeURI(this.form.attr("data-action-url"));
            $.ajax({
                url: formSubmitApi,
                data: this.form.serialize(),
                method: 'post'
            })
                .fail(this.onFailSubmit.bind(this))
                .done(this.onSuccessSubmit.bind(this))
                .always(this.submitAlways.bind(this));
            // Restore captcha input name
            $('[data-recaptcha]', this.options.scope).attr('name', originalCaptchaInputName);
            return true;
        };
        EloquaMasterForm.prototype.getVWOEventValues = function () {
            var el = this.options.scope;
            var country = ($("[name=Country]", el).val() ? $("[name=Country]", el).val() : "no");
            if ($(".business-services-registration-form", this.options.scope).length > 0) {
                this.formName = "Master Lead Form";
            }
            var o = {
                eventName: "contact us",
                formName: this.formName,
                eloquaSubmissionId: this.submissionId,
                country: country,
                pageUrl: window.location.href
            };
            return o;
        };
        EloquaMasterForm.prototype.triggerVWOEventOnDownload = function (e) {
            var download_url = $($(e.target).closest('a')[0]).attr('href');
            var o = {
                downloadFile: true,
                eventName: "download",
                "url_": download_url.indexOf('http') == -1 ? window.location.origin + download_url : download_url
            };
            eventManager.trigger("VWOEvent", o, "assetDownload");
        };
        EloquaMasterForm.prototype.getPiiSafeValues = function () {
            var el = this.options.scope;
            var zipCode = 'n/a';
            var country = ($("[name=Country]", el).val() ? $("[name=Country]", el).val() : "no");
            if (country === 'USA') {
                zipCode = ($("[name=ZipCode]", el).val() ? $("[name=ZipCode]", el).val() : "no");
            }
            var values = [
                "Prefix=" + ($("[name=Prefix]", el).val() ? "yes" : "no"),
                "First Name=" + ($("[name=FirstName]", el).val() ? "yes" : "no"),
                "Last Name=" + ($("[name=LastName]", el).val() ? "yes" : "no"),
                "Work Phone=" + ($("[name=WorkPhone]", el).val() ? "yes" : "no"),
                "Company=" + $("[name=Company]", el).val(),
                "Number Of Employees=" + $("[name=NumberOfEmployees]", el).val(),
                "Country=" + country,
                "ZipCode=" + zipCode,
                "Industry=" + $("[name=Industry]", el).val(),
                "SubIndustry=" + $("[name=SubIndustry]", el).val(),
                "Job Title=" + $("[name=JobTitle]", el).val(),
                "LawJobTitle=" + $("[name=LawJobTitle]", el).val(),
                "Population Served By Agency=" + $("[name=PopulationServedByAgency]", el).val(),
                "RMS=" + $("[name=Rms]", el).val(),
                "When Do You Intend To Purchase=" + $("[name=WhenDoYouIntendToPurchase]", el).val(),
                "How Did You Hear About Us=" + $("[name=HowDidYouHearAboutUs]", el).val(),
                "How Can We Help You=" + ($("[name=HowCanWeHelpYou]", el).val() ? "yes" : "no"),
                "Mark Request As Urgent=" + $("[name=MarkRequestAsUrgent]", el).val(),
                "Receive Email Notifications=" + $("[name=ReceiveEmailNotifications]", el).val(),
                "Asset Url=" + $("[name=AssetUrl]", el).val(),
                "Event Type=" + $("[name=EventType]", el).val(),
                "Event Name=" + $("[name=EventName]", el).val(),
                "Event Location Address=" + $("[name=EventLocationAddress]", el).val(),
                "Asset Type=" + $("[name=AssetType]", el).val(),
                "Asset Name=" + $("[name=AssetName]", el).val(),
                "Product of Interest=" + (($("[name=ProductOfInterest]", el).val() == "" || $("[name=ProductOfInterest]", el).val() == null) ? "undefined" : $("[name=ProductOfInterest]", el).val()),
                "Optanon Active Groups=" + $("[name=OptanonActiveGroups]", el).val(),
                "Solution of Interest=" + (($("[name=AreaOfInterest]", el).val() == "" || $("[name=AreaOfInterest]", el).val() == null) ? "undefined" : $("[name=AreaOfInterest]", el).val()),
                "Request Type=" + $("[name=RequestType]", el).val(),
                "Email Address Status=" + $("[name=EmailAddressStatus]", el).val()
            ];
            return values;
        };
        EloquaMasterForm.prototype.onSuccessSubmit = function (data) {
            this.successLogic(data);
        };
        EloquaMasterForm.prototype.successLogic = function (data) {
            $('.score-well', this.options.scope).show().addClass("in");
            this.form.hide();
            $('.score-well', this.options.scope)[0].scrollIntoView({ behavior: 'smooth' });
            var assetUrl = $('[name="AssetUrl"]', this.options.scope).val();
            //LNRSSUP-549
            var hasAsset = !!($("[name=AssetUrl]", this.options.scope).val());
            var isSubmissionSuccessful = data === true;
            if (isSubmissionSuccessful) {
                console.log('eloqua form submit succeded');
                eventManager.trigger(events.global.formSubmitted, this.formName, this.piiSafeValues, this.submissionId, hasAsset);
                eventManager.trigger("VWOEvent", this.vwoEventValues, "leadSubmits");
                if (hasAsset) {
                    eventManager.trigger("SuccessAsset" + this.options.formId);
                }
                else {
                    eventManager.trigger("SuccessContactUs" + this.options.formId);
                }
            }
            // Trigger VWO tracking for both success and failure
            eventManager.trigger(events.global.vwoEloquaFormSuccess, this.form, isSubmissionSuccessful);
            if (this.options.isAutoResponderEnabled == true) {
                return;
            }
            //Set cookies for media asset form
            var hasVideoButton = $('.score-vimeo-video', this.options.scope);
            var isMediaAssetForm = this.options.scope.className.indexOf("media-asset-form") !== -1;
            if (data === true && assetUrl && isMediaAssetForm && this.options.hasGatedLinkUrl) {
                $('.gated-url-redirect', this.options.scope).show();
            }
            else {
                if (assetUrl && assetUrl.indexOf("/media/") > 0) {
                    $('.download', this.options.scope).show();
                    $('#download', this.options.scope).attr('href', assetUrl);
                    if (assetUrl.indexOf('.pdf') != -1) {
                        $('#download', this.options.scope).attr('target', '_blank');
                    }
                }
            }
            if ((assetUrl && assetUrl.length > 0) || hasVideoButton.length > 0) {
                document.cookie = "Id" + this.options.pageId.Guid + "_" + this.options.itemId.Guid + "= 1; expires = Fri, 31-Dec-9999 23:59:59 GMT";
            }
            $('.video-button', this.options.scope).show();
        };
        EloquaMasterForm.prototype.submitAlways = function (data) {
            $('button[type="submit"]', this.options.scope).prop('disabled', false);
        };
        EloquaMasterForm.prototype.onFailSubmit = function (data) {
            var error = data.responseJSON;
            errorHandler.logError(error);
            this.successLogic(data);
        };
        EloquaMasterForm.prototype.onCountryChanged = function (e) {
            var selectedCountry = e.target.value;
            var zipContainer = $('[name="ZipCode"]', this.options.scope).closest('.form-group');
            // Set ZipCode for US or hide for other countries
            if ((selectedCountry == 'United States' || selectedCountry == 'USA')) {
                if (this.locationInfo.Country == 'United States' || this.locationInfo.Country == 'USA') {
                    //set value of zipcode based on location
                    if (this.locationInfo.ZipCode !== '') {
                        $('[name="ZipCode"]', this.options.scope).val(this.locationInfo.ZipCode);
                    }
                }
                zipContainer.show();
                $('input[name="SkipZipCodeValidation"]', this.options.scope).val('');
            }
            else {
                $('input[name="SkipZipCodeValidation"]', this.options.scope).val('True');
                $('[name="ZipCode"]', this.options.scope).val('');
                zipContainer.hide();
            }
            this.updateValidatePhone();
            var countryPhoneCodeSelect = $('[name="CountryPhoneCode"]', this.options.scope);
            if (countryPhoneCodeSelect.length > 0) {
                if (countryPhoneCodeSelect.val() != selectedCountry) {
                    countryPhoneCodeSelect.val(selectedCountry).change();
                }
            }
            // Re-validate phone and email on country change
            BriteVerifyValidationHelper.default.validateWorkEmail(this.form, this.isBusinessServicesForm);
            BriteVerifyValidationHelper.default.verifyPhoneWithCountryCode(this.form, this.validatePhone);
        };
        EloquaMasterForm.prototype.onIndustryChanged = function (e) {
            var selectedIndustry = e.target.value;
            if (e.target.className.indexOf('business-services-') === -1) {
                // Get sub industries for currently selected industry
                this.loadSubIndustries(selectedIndustry);
                //Commenting below code for to permanently hide AreaOfInterest field. Task : LNRSSUP-1871
                //if (e.target.classList.contains('uk-lead-form')) {
                //	this.updateAreaOfInterest(selectedIndustry);
                //} else {
                //	// this property introduces additional logic for visibility of Area of Interest field
                //	if (!this.options.hasOwnProperty("treatmentMSIDToAreaOfInterestMap")) {
                //		this.updateAreaOfInterestVisibility(selectedIndustry);
                //	}
                //}
                // Show one of the JobTitle dropdowns based on industry
                this.showOneOfJobTitleDropdownsBasedOnIndustry(selectedIndustry);
                // Toggle keep me informed checkbox visibility based whether it's empty or not
                $('[name="ReceiveEmailNotificationsGlobal"]', this.options.scope).closest('.form-group')
                    .toggleClass('hidden', $('[name="Industry"]', this.options.scope).val() === "Insurance");
            }
        };
        EloquaMasterForm.prototype.showOneOfJobTitleDropdownsBasedOnIndustry = function (industry) {
            var showJobTitle = industry != 'Law Enf. & Public safety';
            $('[name="JobTitle"]', this.options.scope).closest('.form-group').toggleClass('hidden', !showJobTitle);
            $('[name="LawJobTitle"]', this.options.scope).closest('.form-group').toggleClass('hidden', showJobTitle);
        };
        EloquaMasterForm.prototype.updateAreaOfInterestVisibility = function (industry) {
            //if (this.options.globalAreasOfInterest) {
            if (industry == 'Financial Services' || industry == 'Other') {
                $('.area-of-interests', this.options.scope).removeClass('hidden');
                $('input[name="SkipAreaOfInterestValidation"]', this.options.scope).val('');
            }
            else {
                $('.area-of-interests', this.options.scope).addClass('hidden');
                $('input[name="SkipAreaOfInterestValidation"]', this.options.scope).val('True');
            }
            //}
        };
        EloquaMasterForm.prototype.updateAreaOfInterest = function (industry) {
            if (this.options.ukAreaOfInterest && this.options.ukAreaOfIntersetForInsurance) {
                if (industry == 'Insurance') {
                    this.rebuildAreaOfInterest(this.options.ukAreaOfIntersetForInsurance);
                }
                else {
                    this.rebuildAreaOfInterest(this.options.ukAreaOfInterest);
                }
            }
        };
        EloquaMasterForm.prototype.loadSubIndustries = function (industry) {
            var languageName = $('[name="LanguageName"]', this.options.scope).val();
            var itemWebApiUrl = "/-/item/v2/?language=" + languageName + "&fields=value|text&query=";
            var query = "/sitecore/content/LNRS/LNRS Settings//*[@@id='{1B17982E-9223-4AA2-8A32-DBF317CCF858}']/*[@Value='" + industry + "']/*";
            var encodedQuery = encodeURIComponent(query);
            // Handle situation when industry is not selected
            if (!industry) {
                this.onSubIndustryDataLoaded({ result: [] });
                return;
            }
            $.ajax({
                url: itemWebApiUrl + encodedQuery,
                method: 'get',
                cache: true
            })
                .done(this.onSubIndustryDataLoaded.bind(this));
        };
        EloquaMasterForm.prototype.onSubIndustryDataLoaded = function (data) {
            var items = data.result.items;
            var subIndustryItems = [];
            for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
                var item = items_1[_i];
                if (item.Fields['{FF438BF6-9409-45F5-ABEA-CA2049239A0F}'].Value)
                    subIndustryItems.push(item);
            }
            this.rebuildSubIndustryDropdown(subIndustryItems);
            $('[name="SubIndustry"]', this.options.scope).closest('.btn-group')
                .removeClass('input-validation-error');
            // Toggle SubIndustry dropdown validation based whether it's empty or not
            $('[name="SkipSubIndustryValidation"]', this.options.scope).val(subIndustryItems.length ? '' : 'True');
            //Skip Law Enforcement validation by default to remove Subindustry error message on page load
            $('[name="SkipValidationForFieldsBasedOnSpecificSubIndustry"]', this.options.scope)
                .val('True');
            // Toggle SubIndustry dropdown visibility based whether it's empty or not
            $('[name="SubIndustry"]', this.options.scope).closest('.form-group')
                .toggleClass('hidden', !subIndustryItems.length);
            eventManager.trigger("SubIndustriesLoaded");
        };
        EloquaMasterForm.prototype.rebuildAreaOfInterest = function (areaOfInterests) {
            var label = $("label[for='AreaOfInterest']");
            var areaOfInterestLabel = label.html();
            var industryLabel = $("label[for='Industry']").html();
            var selectedIndustryOption = $('[name="Industry"] option:selected', this.options.scope);
            var selectedIndustryTitle = selectedIndustryOption.val();
            if (industryLabel != selectedIndustryTitle && this.options.ukAreaOfInterestVisible) {
                $('.area-of-interests', this.options.scope).removeClass('hidden');
            }
            var options = [];
            if (this.options.ukAreaOfInterestVisible) {
                for (var _i = 0, areaOfInterests_1 = areaOfInterests; _i < areaOfInterests_1.length; _i++) {
                    var item = areaOfInterests_1[_i];
                    var option = {
                        text: item.Text,
                        value: item.Value,
                        selected: item.Text == this.options.ukPreselectedAreaOfInterest,
                        disabled: false
                    };
                    options.push(option);
                }
            }
            else {
                var option = {
                    text: this.options.ukPreselectedAreaOfInterest,
                    value: this.options.ukPreselectedAreaOfInterest,
                    selected: true,
                    disabled: false
                };
                options.push(option);
            }
            var template = '{{#.}}<option value="{{value}}" {{#selected}}selected="selected"{{/selected}} {{#disabled}}disabled="disabled"{{/disabled}}>{{text}}</option>{{/.}}';
            var mustache = require('mustache');
            var html = mustache.render(template, options);
            var areaOfInterestsSelect = $('[name="AreaOfInterest"]', this.options.scope);
            areaOfInterestsSelect.html(html);
            areaOfInterestsSelect.selectpicker('refresh');
        };
        EloquaMasterForm.prototype.rebuildSubIndustryDropdown = function (subIndustryItems) {
            var subIndustrySelect = $('[name="SubIndustry"]', this.options.scope);
            // Get SubIndustry dropdown title
            var selectedIndustryOption = $('[name="Industry"] option:selected', this.options.scope);
            var industryTitle = selectedIndustryOption.val() ?
                selectedIndustryOption.text() :
                subIndustrySelect.data('industry-title');
            var subIndustryTitle = '';
            var subIndustryDataTitle = subIndustrySelect.data('sub-industry-title');
            if (typeof subIndustryDataTitle != 'undefined') {
                subIndustryTitle = subIndustryDataTitle;
            }
            else {
                var label = $("label[for='" + subIndustrySelect.attr('id') + "']");
                subIndustryTitle = label.html();
            }
            var defaultTitle = industryTitle + ' ' + subIndustryTitle;
            // Build dropdown options
            // defaultOption should have 'disabled: false' due to a bug in Score https://brainjocks.atlassian.net/browse/SCORE-1585
            // otherwise validation treats disabled value as valid one
            var defaultOption = {
                text: defaultTitle, value: null, selected: true, disabled: false
            };
            var options = [defaultOption];
            for (var _i = 0, subIndustryItems_1 = subIndustryItems; _i < subIndustryItems_1.length; _i++) {
                var item = subIndustryItems_1[_i];
                var option = {
                    text: item.Fields['{FF438BF6-9409-45F5-ABEA-CA2049239A0F}'].Value,
                    value: item.Fields['{39BC23A7-4842-431A-ACED-F0A15EAB496D}'].Value,
                    selected: false,
                    disabled: false
                };
                options.push(option);
            }
            // render dropdown options
            var template = '{{#.}}<option value="{{value}}" {{#selected}}selected="selected"{{/selected}} {{#disabled}}disabled="disabled"{{/disabled}}>{{text}}</option>{{/.}}';
            var mustache = require('mustache');
            var html = mustache.render(template, options);
            subIndustrySelect.html(html);
            // refresh selectpicker to have new options
            subIndustrySelect.selectpicker('refresh');
            // Fire change event since dropdown is changed to notify other fields that depend on sub industry
            // subIndustrySelect.trigger('change');
        };
        EloquaMasterForm.prototype.onSubIndustryChanged = function (e) {
            var selectedSubIndustry = e.target.value;
            var subIndustriesToCheck = [
                'LEPS: Citizen Online Reporting',
                'LEPS: Crash Reporting',
                'LEPS: Personnel Training',
                'LEPS: Scheduling Software'
            ];
            var isMatched = subIndustriesToCheck.some(function (s) { return s == selectedSubIndustry; });
            // Toggle fields visibility based selected sub industry
            $('[name="PopulationServedByAgency"]', this.options.scope).closest('.form-group')
                .toggleClass('hidden', !isMatched);
            $('[name="Rms"]', this.options.scope).closest('.form-group')
                .toggleClass('hidden', !isMatched);
            $('[name="WhenDoYouIntendToPurchase"]', this.options.scope).closest('.form-group')
                .toggleClass('hidden', !isMatched);
            $('[name="HowDidYouHearAboutUs"]', this.options.scope).closest('.form-group')
                .toggleClass('hidden', !isMatched);
            // Enable validation if selected sub industry is in the list of specific sub industries
            $('[name="SkipValidationForFieldsBasedOnSpecificSubIndustry"]', this.options.scope)
                .val(isMatched ? '' : 'True');
        };
        return EloquaMasterForm;
    }());
    function init(args) {
        new EloquaMasterForm(args);
    }
    return init;
});
///<amd-module name="Components/Resources/MasonryResourceListing"/>
define("Components/Resources/MasonryResourceListing", ["require", "exports", "jquery", "Utility/SiteContext", "instantsearch", "Globalization/Dictionary", "hierarchicalmenuwidget", "text!Components/Resources/Templates/MasonryResourceListingItem.html", "matchHeight"], function (require, exports, $, siteContext, instantsearch, dictionary, hierarchicalmenuwidget) {
    "use strict";
    //declare namespace MasonryResourceListing {
    //}
    var MasonryResourceListing = /** @class */ (function () {
        function MasonryResourceListing(args) {
            var _this = this;
            this.transformHitItem = function (hit) {
                var isDownloadItem = hit["_template"] === '{3760C9B0-040B-441B-89D4-D36F0DD765AA}';
                hit["readMore"] = _this.options.readMore;
                hit["_resource_type"] = dictionary.translate(hit["_resource_type"]);
                hit["isDownloadItem"] = isDownloadItem;
                hit["url"] = isDownloadItem ? hit["link to pdf"] : hit["url"];
                //LNRSSUP-324
                var tileDescription = hit["tile description"];
                if (tileDescription) {
                    if (tileDescription.length > 0) {
                        hit["meta description"] = tileDescription;
                    }
                }
                return hit;
            };
            this.options = args;
            this.scope = args.scope;
            this.resourceTypeContainer = this.scope.querySelector('[data-id="resource-types"]');
            this.solutionContainer = this.scope.querySelector('[data-id="solutions"]');
        }
        MasonryResourceListing.prototype.init = function () {
            this.search = instantsearch({
                appId: this.options.algoliaAppId,
                apiKey: this.options.algoliaApiKey,
                indexName: this.options.algoliaIndexName,
                urlSync: {
                    trackedParameters: ['query', 'attribute:*', 'index', 'hitsPerPage'] //not sync page as it causes issues with back button
                },
                searchParameters: {
                    facets: ["_language"],
                    facetsRefinements: {
                        _language: [siteContext.getContextLanguage()]
                    },
                    disjunctiveFacets: ["_template"],
                    disjunctiveFacetsRefinements: {
                        _template: ['{351839DE-0AA0-448A-8832-2429282C1B78}', '{3760C9B0-040B-441B-89D4-D36F0DD765AA}']
                    }
                }
            });
            this.search.on('render', this.onRender.bind(this));
            $(document).on("click", this.onDocumentClick.bind(this));
            this.initHits();
            this.initIndustryFilter();
            this.initResourceTypeFilter();
            this.initSolutionFilter();
            this.search.start();
            this.checkUrlResourceFacet();
            this.filterButtonCollapse();
        };
        MasonryResourceListing.prototype.checkUrlResourceFacet = function () {
            if (typeof this.search.helper.state.hierarchicalFacetsRefinements['_resource_type'] === 'undefined') {
                var resourceFacet = '';
                if (window.location.href.includes('insights-resources/article')) {
                    resourceFacet = dictionary.translate('Article');
                }
                else if (window.location.href.includes('insights-resources/brochure')) {
                    resourceFacet = dictionary.translate('Brochure');
                }
                else if (window.location.href.includes('insights-resources/case-study')) {
                    resourceFacet = dictionary.translate('Case Study');
                }
                else if (window.location.href.includes('insights-resources/infographic')) {
                    resourceFacet = dictionary.translate('Infographic');
                }
                else if (window.location.href.includes('insights-resources/presentation')) {
                    resourceFacet = dictionary.translate('Presentation');
                }
                else if (window.location.href.includes('insights-resources/research')) {
                    resourceFacet = dictionary.translate('Research');
                }
                else if (window.location.href.includes('insights-resources/video')) {
                    resourceFacet = dictionary.translate('Video');
                }
                else if (window.location.href.includes('insights-resources/webinar')) {
                    resourceFacet = dictionary.translate('Webinar');
                }
                else if (window.location.href.includes('insights-resources/white-paper')) {
                    resourceFacet = dictionary.translate('White Paper');
                }
                else if (window.location.href.includes('insights-resources/podcast')) {
                    resourceFacet = dictionary.translate('Podcast');
                }
                else if (window.location.href.includes('insights-resources/blog-post')) {
                    resourceFacet = dictionary.translate('Blog Post');
                }
                else if (window.location.href.includes('insights-resources/e-book')) {
                    resourceFacet = dictionary.translate('E-Book');
                }
                if (resourceFacet.length > 0) {
                    this.search.helper.toggleFacetRefinement('_resource_type', resourceFacet);
                    this.search.helper.search();
                }
            }
        };
        MasonryResourceListing.prototype.initHits = function () {
            var hitsElement = this.scope.querySelector(".masonry-resource-listing-hits");
            var searchResultWidget = instantsearch.widgets.infiniteHits({
                container: hitsElement,
                templates: {
                    empty: dictionary.translate('No Results'),
                    item: require('text!Components/Resources/Templates/MasonryResourceListingItem.html')
                },
                transformData: {
                    item: this.transformHitItem.bind(this)
                },
                showMoreLabel: dictionary.translate('Load More'),
                hitsPerPage: this.getNumberOfTilesPerPageBasedOnDevice()
            });
            this.search.addWidget(searchResultWidget);
        };
        MasonryResourceListing.prototype.initIndustryFilter = function () {
            this.industryFilterWidget = hierarchicalmenuwidget(this.options.algoliaAppId, this.options.algoliaApiKey, this.options.algoliaIndexName, siteContext.getContextLanguage(), this.search, 2, dictionary.translate('All Industries'), '[data-id="industries"]', "hierarchical industries", "lvl0", "lvl1", ["hierarchical industries.lvl0", "hierarchical industries.lvl1"], this.options.industriesWithSubIndustries, null, null);
            this.search.addWidget(this.industryFilterWidget.widget);
        };
        MasonryResourceListing.prototype.initResourceTypeFilter = function () {
            var widget = instantsearch.widgets.menu({
                container: this.resourceTypeContainer,
                attributeName: '_resource_type',
                sortBy: ['name:asc', 'count:desc'],
                autoHideContainer: false,
                templates: {
                    header: dictionary.translate('All Resource Types')
                },
                collapsible: {
                    collapsible: true,
                    collapsed: true
                }
            });
            this.search.addWidget(widget);
        };
        MasonryResourceListing.prototype.initSolutionFilter = function () {
            var widget = instantsearch.widgets.menu({
                container: this.solutionContainer,
                sortBy: ['name:asc', 'count:desc'],
                attributeName: 'solutions',
                autoHideContainer: false,
                templates: {
                    header: dictionary.translate('All Solutions')
                },
                collapsible: {
                    collapsible: true,
                    collapsed: true
                }
            });
            this.search.addWidget(widget);
        };
        MasonryResourceListing.prototype.onRender = function () {
            this.industryFilterWidget.onRenderCallback();
            this.onResourceTypeFilterRender();
            this.onSolutionFilterRender();
            var offset = window.pageYOffset;
            $.fn.matchHeight._apply($('.masonry-resource-listing-item'));
            $.fn.matchHeight._maintainScroll = true;
            $(document).scrollTop(offset);
            $('.masonry-resource-listing-item').hover(function (e) {
                e.preventDefault();
                var $link = $(e.currentTarget).find('.masonry-resource-listing-item-link');
                if ($link.length) {
                    $link.show();
                }
            }, function (e) {
                e.preventDefault();
                var $link = $(e.currentTarget).find('.masonry-resource-listing-item-link');
                if ($link.length) {
                    $link.removeAttr('style');
                }
            });
        };
        MasonryResourceListing.prototype.onResourceTypeFilterRender = function () {
            // Update header box with currently selected value
            var facet = this.search.helper.state.hierarchicalFacetsRefinements['_resource_type'];
            var selectedValue = facet && facet[0] ?
                facet[0] :
                dictionary.translate('All Resource Types');
            var headerContainer = this.resourceTypeContainer.querySelector(".ais-header");
            headerContainer.textContent = selectedValue;
            // disable the dropdown if no options
            this.disableDropdownIfNoOptions($(headerContainer).closest('div[data-id]'));
        };
        MasonryResourceListing.prototype.onSolutionFilterRender = function () {
            var facet = this.search.helper.state.hierarchicalFacetsRefinements['solutions'];
            var selectedValue = facet && facet[0] ?
                facet[0] :
                dictionary.translate('All Solutions');
            var headerContainer = this.solutionContainer.querySelector(".ais-header");
            headerContainer.textContent = selectedValue;
            // disable the dropdown if no options
            this.disableDropdownIfNoOptions($(headerContainer).closest('div[data-id]'));
        };
        MasonryResourceListing.prototype.disableDropdownIfNoOptions = function (dropdownContainer) {
            var shouldDisable = dropdownContainer.find('.ais-menu--list').children().length === 0;
            dropdownContainer.toggleClass('masonry-resource-listing-filter-disabled', shouldDisable);
        };
        MasonryResourceListing.prototype.stopEventPropagation = function (e) {
            e.stopPropagation();
            e.preventDefault();
            e.stopImmediatePropagation();
        };
        MasonryResourceListing.prototype.closeAllExceptSelector = function (dropdowns, selector) {
            for (var i = 0; i < dropdowns.length; i++) {
                if (!($(dropdowns[i]).closest(selector).length > 0)) {
                    dropdowns[i].classList.add('ais-root__collapsed');
                }
            }
        };
        MasonryResourceListing.prototype.closeAllDropDownsExceptClicked = function (target) {
            var allDropDowns = this.scope.querySelectorAll(".ais-root__collapsible");
            var industries = target.closest('div[data-id="industries"]');
            if (industries.length > 0) {
                this.closeAllExceptSelector(allDropDowns, 'div[data-id="industries"]');
            }
            var resourceTypes = target.closest('div[data-id="resource-types"]');
            if (resourceTypes.length > 0) {
                this.closeAllExceptSelector(allDropDowns, 'div[data-id="resource-types"]');
            }
            var solutions = target.closest('div[data-id="solutions"]');
            if (solutions.length > 0) {
                this.closeAllExceptSelector(allDropDowns, 'div[data-id="solutions"]');
            }
        };
        MasonryResourceListing.prototype.onDocumentClick = function (e) {
            var target = $(e.target);
            var allIndustryLable = dictionary.translate('All Industries');
            var allResourcesLabel = dictionary.translate('All Resource Types');
            var allSolutionsLabel = dictionary.translate('All Solutions');
            var search = this.search;
            this.closeAllDropDownsExceptClicked(target.parent());
            //LNRSSUP-494 close industires dropdown even if there is sub industries to list
            if (target.hasClass('ais-hierarchical-menu--item') || target.hasClass('ais-hierarchical-menu--link')) {
                console.log(target);
                var industries = target.closest('div[data-id="industries"]');
                if (industries.length > 0) {
                    var dropDown = target.closest('.ais-root__collapsible');
                    dropDown.addClass('ais-root__collapsed');
                }
            }
            if ((target.hasClass('ais-menu--header') || target.hasClass('ais-hierarchical-menu--header')) && target.parent().hasClass('ais-root__collapsed')) {
                target.parent().removeClass('ais-root__collapsed');
                // Make hierarchical menu widget uncontrolled by React as well as rest
                if (target.parent().parent().data('id') === 'industries') {
                    if (target.text() !== allIndustryLable) {
                        target.text(allIndustryLable);
                    }
                    this.stopEventPropagation(e);
                }
                if (target.parent().parent().data('id') === 'resource-types') {
                    if (target.text() !== allResourcesLabel) {
                        target.text(allResourcesLabel);
                    }
                    //Commented the code to resolve issue LNRSSUP-1667
                    //this.stopEventPropagation(e);
                }
                else if (target.parent().parent().data('id') === 'solutions') {
                    if (target.text() !== allSolutionsLabel) {
                        target.text(allSolutionsLabel);
                    }
                    //Commented the code to resolve issue LNRSSUP-1667
                    //this.stopEventPropagation(e);
                }
            }
            else if (target.hasClass('ais-menu--header') && !target.parent().hasClass('ais-root__collapsed') && target.text() === allResourcesLabel) {
                search.helper.clearRefinements('_resource_type');
                search.helper.search();
            }
            else if (target.hasClass('ais-menu--header') && !target.parent().hasClass('ais-root__collapsed') && target.text() === allSolutionsLabel) {
                search.helper.clearRefinements('solutions');
                search.helper.search();
            }
            else {
                if (target.parent().parent().data('id') === 'resource-types') {
                    this.onResourceTypeFilterRender();
                }
                else if (target.parent().parent().data('id') === 'solutions') {
                    this.onSolutionFilterRender();
                }
            }
            if (!target.parent('[data-id="resource-types"]').length && !target.hasClass('ais-menu--header')) {
                if (!$('[data-id="resource-types"]').find('.ais-menu').hasClass('ais-root__collapsed')) {
                    var resourcesFacet = search.helper.state.hierarchicalFacetsRefinements['_resource_type'];
                    var resorcesHeaderContainer = $('[data-id="resource-types"]').find('.ais-header');
                    if (resourcesFacet && resourcesFacet[0]) {
                        resorcesHeaderContainer.text(resourcesFacet[0]);
                    }
                    resorcesHeaderContainer.click();
                }
            }
            if (!target.parent('[data-id="solutions"]').length && !target.hasClass('ais-menu--header')) {
                if (!$('[data-id="solutions"]').find('.ais-menu').hasClass('ais-root__collapsed')) {
                    var solutionsFacet = search.helper.state.hierarchicalFacetsRefinements['solutions'];
                    var solutionsHeaderContainer = $('[data-id="solutions"]').find('.ais-header');
                    if (solutionsFacet && solutionsFacet[0]) {
                        solutionsHeaderContainer.text(solutionsFacet[0]);
                    }
                    solutionsHeaderContainer.click();
                }
            }
        };
        MasonryResourceListing.prototype.getLayoutType = function () {
            var w = window.innerWidth;
            return w < 768 ? "Mobile" : w >= 768 && w <= 991 ? "Tablet" : "Desktop";
        };
        MasonryResourceListing.prototype.filterButtonCollapse = function () {
            $('.btn-filter').on('click', function (e) {
                e.preventDefault();
            });
            $('.score-center').off('click');
            if ($(window).width() < 992) {
                $('.score-center').on('click', '.btn-filter', function () {
                    $('.masonry-resource-listing-filters').slideToggle();
                });
                $('.masonry-resource-listing-filters').hide();
            }
        };
        ;
        MasonryResourceListing.prototype.getNumberOfTilesPerPageBasedOnDevice = function () {
            var numberOfTiles;
            var layoutType = this.getLayoutType();
            switch (layoutType) {
                case "Tablet":
                    numberOfTiles = this.options.numberOfTilesForTablet;
                    break;
                case "Mobile":
                    numberOfTiles = this.options.numberOfTilesForMobile;
                    break;
                default:
                    numberOfTiles = this.options.numberOfTilesForDesktop;
                    break;
            }
            if (numberOfTiles == null || numberOfTiles === 0) {
                numberOfTiles = 9;
            }
            return numberOfTiles;
        };
        return MasonryResourceListing;
    }());
    function init(args) {
        var component = new MasonryResourceListing(args);
        component.init();
    }
    return init;
});
///<amd-module name="Components/Validation/ReCaptcha"/>
define("Components/Validation/ReCaptcha", ["require", "exports", "jquery", "eventManager"], function (require, exports, $) {
    "use strict";
    var eventManager = require("eventManager");
    var ReCaptcha = /** @class */ (function () {
        function ReCaptcha(options) {
            this.options = options;
            this.form = $(this.options.scope).closest("form");
        }
        ReCaptcha.prototype.init = function () {
            this.enableCaptchaValidation();
            eventManager.subscribe('RecaptchaApiLoaded', this.onCaptchaApiLoaded.bind(this));
        };
        ReCaptcha.prototype.onCaptchaApiLoaded = function () {
            var captchaContainer = $('.g-recaptcha', this.options.scope).get(0);
            grecaptcha.render(captchaContainer, {
                sitekey: this.options.siteKey,
                callback: this.onCaptchaVerified.bind(this),
                'expired-callback': this.onCaptchaExpired.bind(this)
            });
        };
        /**
        Enable Jquery Unobtrusive Validation for Google ReCaptcha.
        **/
        ReCaptcha.prototype.enableCaptchaValidation = function () {
            var formValidator = this.form.data("validator");
            formValidator.settings.ignore = ":hidden:not([data-recaptcha])";
        };
        ReCaptcha.prototype.onCaptchaVerified = function (response) {
            // Set any value to bypass Required client side validation
            $('[data-recaptcha]', this.options.scope).val(response).validate();
            //form.validate().element('#FieldId');
        };
        ReCaptcha.prototype.onCaptchaExpired = function () {
            $('[data-recaptcha]', this.options.scope).val();
            console.log('captcha expired.');
        };
        return ReCaptcha;
    }());
    function init(args) {
        var captcha = new ReCaptcha(args);
        captcha.init();
    }
    return init;
});
define("Utility/GeoService", ["require", "exports", "jquery", "geoip"], function (require, exports, $, geoip) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var GeoService = /** @class */ (function () {
        function GeoService() {
            this.deferred = $.Deferred();
        }
        GeoService.prototype.GetLocationInfoAsync = function () {
            geoip.city(this.onSuccess.bind(this), this.onError.bind(this));
            return this.deferred.promise();
        };
        GeoService.prototype.onSuccess = function (geoipResponse) {
            if (geoipResponse) {
                var countryData = geoipResponse.country;
                var postalData = geoipResponse.postal;
                this.locationInfo = {
                    country: countryData != null ? countryData.names.en : '',
                    countryCode: countryData != null ? countryData.iso_code : '',
                    zipCode: postalData != null ? postalData.code : ''
                };
            }
            ;
            this.deferred.resolve(this.locationInfo);
        };
        ;
        GeoService.prototype.onError = function (error) {
            this.deferred.resolve();
        };
        ;
        return GeoService;
    }());
    exports.GeoService = GeoService;
});
//# sourceMappingURL=ts.bundle.js.map;
define("Areas/LNRS/js/ts.bundle", function(){});

